export const getFileExt = (url: string) => {
  const ext = url.split('.').pop() || '';
  return ext.replace(/\?.+/, '');
};
